<template>
  <div class="login-container">
    <form class="login-card" @submit.prevent="onSubmit">
      <h1 class="login-title">Choose a new password</h1>

      <label class="login-label">New Password</label>
      <input
        v-model="newPassword"
        type="password"
        required
        class="login-input"
        placeholder="New password"
        autocomplete="new-password"
      />

      <label class="login-label">Confirm New Password</label>
      <input
        v-model="confirmPassword"
        type="password"
        required
        class="login-input"
        placeholder="Confirm password"
        autocomplete="new-password"
      />

      <p class="login-hint">
        Password must be at least 12 characters and include at least 3 of:
        lowercase, uppercase, number, symbol.
      </p>

      <p v-if="error" class="login-error">{{ error }}</p>
      <p v-if="message" class="login-success">{{ message }}</p>

      <button :disabled="loading" class="login-button">
        <span v-if="!loading">Reset password</span>
        <span v-else>Resetting…</span>
      </button>

      <p class="back-link">
        <router-link to="/login">Back to login</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ResetPassword',
  data() {
    return {
      email: '',
      token: '',
      newPassword: '',
      confirmPassword: '',
      loading: false,
      error: null,
      message: null,
    }
  },
  mounted() {
    this.email = this.$route.query.email || ''
    this.token = this.$route.query.token || ''

    if (!this.email || !this.token) {
      this.error = 'Invalid reset link.'
    }
  },
  methods: {
    async onSubmit() {
      this.error = null
      this.message = null

      if (!this.email || !this.token) {
        this.error = 'Invalid reset link.'
        return
      }

      if (!this.newPassword || !this.confirmPassword) {
        this.error = 'Both password fields are required.'
        return
      }

      if (this.newPassword !== this.confirmPassword) {
        this.error = 'Passwords do not match.'
        return
      }

      this.loading = true

      try {
        const { data } = await axios.post('/auth/reset-password', {
          email: this.email,
          token: this.token,
          new_password: this.newPassword,
        })

        this.message = data?.message || 'Password has been reset.'

        setTimeout(() => {
          this.$router.push('/login')
        }, 1500)
      } catch (e) {
        this.error = e?.response?.data?.error || e?.message || 'Unable to reset password.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0b0101;
  padding: 24px;
  box-sizing: border-box;
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-sizing: border-box;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  text-align: left;
  font-family: Garamond, serif;
  color: #2c3e50;
}

.login-title {
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
}

.login-label {
  display: block;
  font-size: 14px;
  margin: 10px 0 6px 0;
}

.login-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  box-sizing: border-box;
}

.login-input:focus {
  border-color: #2c3e50;
}

.login-error {
  color: #b00020;
  font-size: 14px;
  margin-top: 10px;
}

.login-success {
  color: #166534;
  font-size: 14px;
  margin-top: 10px;
}

.login-button {
  width: 100%;
  margin-top: 16px;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: #000000;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-hint {
  font-size: 12px;
  color: #4b5563;
  margin-top: 10px;
}

.back-link {
  text-align: center;
  font-size: 13px;
  margin-top: 14px;
}

.back-link a {
  color: #2c3e50;
  text-decoration: underline;
}
</style>